import VandyLogo from '../assets/Vanderbilt-University-Logo.png';
import {
  ChakraProvider, 
  theme,
  Box,
  chakra,
  Container,
  Stack,
  Text,
  useColorModeValue,
  VisuallyHidden,
  Divider,
  Link,
} from '@chakra-ui/react';
import { ReactNode } from 'react';


// pulled from navBar.js
const MenuItem = ({ children, isLast, to = '/' }) => {
  return (
    <Text
      mb={{ base: isLast ? 0 : 8, sm: 0 }}
      mr={{ base: 0, sm: isLast ? 0 : 8 }}
      display="block"
    >
      <Link href={to}>{children}</Link>
    </Text>
  );
};

export default function Footer() {
  return (
    <ChakraProvider theme={theme}>
    <Box>
      <Container
        as={Stack}
        maxW={'6xl'}
        py={4}
        direction={{ base: 'column', md: 'row' }}
        spacing={4}
        justify={{ base: 'center', md: 'space-between' }}
        align={{ base: 'center', md: 'center' }}>

        <Box w="200px">
          <MenuItem to="https://www.vanderbilt.edu/"> <img style={{width: (248/2), height: (130/2)}} src={VandyLogo} alt = "Vanderbilt Logo" /></MenuItem>
        </Box>

        <Text fontSize="sm" as='i'>Developed by Alessandra P, Max M, Sera E, and Trevor J.</Text>

      </Container>
    </Box>
    </ChakraProvider>
  );
}


/*
        <Stack justify="space-between" direction="row" align="center">
            <RateMyClassLogo />
            <Stack spacing={{ base: '4', md: '5' }}>
            <Text fontSize="sm" color="subtle">
                &copy; {new Date().getFullYear()} RateMyVandyCourse.com, All rights reserved.
            </Text>
            <Text fontSize="sm" color="subtle">
                Proudly made at Vanderbilt University by Alessandra Priolo, Maximillian Moundas, Sera Eviner, and Trevor Jones.
            </Text>
            <Text fontSize="sm" color="subtle">
                [Deployed April 2023]
            </Text>
            </Stack>
        </Stack>
*/
